export const MIN_INTERNATIONAL_PHONE_LENGTH = 5;
export const MAX_INTERNATIONAL_PHONE_LENGTH = 15;

export const PHONE_CONFIG = {
  "+91": {
    minLength: 10,
    maxLength: 10,
    pattern: "[6-9]\\d{9}",
  },
  "+1": {
    minLength: 10,
    maxLength: 10,
    pattern: "[2-9]\\d{9}",
  },
  "+971": {
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
  },
  "+966": {
    minLength: 9,
    maxLength: 9,
    pattern: "5\\d{8}",
  },
  "+974": {
    minLength: 8,
    maxLength: 8,
    pattern: "[3567]\\d{7}",
  },
  "+968": {
    minLength: 8,
    maxLength: 8,
    pattern: "[79]\\d{7}",
  },
  "+965": {
    minLength: 8,
    maxLength: 8,
    pattern: "[569]\\d{7}",
  },
  "+973": {
    minLength: 8,
    maxLength: 8,
    pattern: "[36]\\d{7}",
  },
};

export const getPhoneConfigForIsd = (isdCode) =>
  PHONE_CONFIG[isdCode] || {
    minLength: MIN_INTERNATIONAL_PHONE_LENGTH,
    maxLength: MAX_INTERNATIONAL_PHONE_LENGTH,
    pattern: "\\d+",
  };
